import React, { useEffect, useState } from 'react';
import { Logo } from '../ui/Logo';
import { navLinks } from '../../data/content';
import { applicationFormUrl } from '../../data/contact';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color] duration-200 ease-out ${scrolled ? 'border-line bg-ink/95 backdrop-blur' : 'border-transparent bg-transparent'}`} data-id="element-60" data-mp="1hqf3kqoz9aoz">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8" aria-label="Principal" data-id="element-61" data-mp="1rqfr6otvqcyz">
        <Logo data-id="element-62" data-mp="2y71ao06sxdtx" />
        <ul className="hidden items-center gap-8 md:flex" data-id="element-63" data-mp="3341fy8vtucjz">
          {navLinks.map(link => <li key={link.href} data-id="element-64" data-mp="335ultlym8sqx">
              <a href={link.href} className="text-sm font-medium text-muted transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3bpk7upbhndqy">
                {link.label}
              </a>
            </li>)}
        </ul>
        <a href={applicationFormUrl} target="_blank" rel="noopener noreferrer" className="whitespace-nowrap rounded-md bg-brand px-4 py-2 font-display text-base font-bold uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:bg-neon" data-id="element-66" data-mp="2xphqd473emc8">
          <span className="sm:hidden" data-id="element-67" data-mp="2jxusx11ez7rv">Diagnóstico gratis</span>
          <span className="hidden sm:inline" data-id="element-68" data-mp="2jw07zmq57fns">Quiero mi diagnóstico gratis</span>
        </a>
      </nav>
    </header>;
}